



























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import quotationsRepository from '@/services/quotationsRepository';

@Component({
  components: {

  },
})
export default class QuotationsStats extends Vue {
  private loading: boolean = false;
  private stats: IQuotationStats | null = null;

  public async mounted() {
    try {
      this.loading = true;
      this.stats = (await quotationsRepository.getStats()).data;
    } catch {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  public showQuotations(status: any) {
    status = '' + status;
    this.$router.push({ name: 'quotationsOverview', query: { status } });
  }
}
